import { TutorialArrowPosition, TutorialPlacement, TutorialProducts } from '../types/dashboard.types'

export interface TutorialStep {
  target: string
  icon: string
  emoji: string
  disableBeacon: boolean
  placement: TutorialPlacement
  arrowPlacement: TutorialPlacement
  arrowPosition: TutorialArrowPosition
  offset: number
}

export type TutorialProductStepsType = {
  [key in TutorialProducts]: TutorialStep[]
}

export const TutorialProductSteps: TutorialProductStepsType = {
  [TutorialProducts.AVATAR_TUTORIAL]: [
    {
      target: '.create-avatar-tutorial-step-1',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.BOTTOM,
      arrowPlacement: TutorialPlacement.TOP,
      arrowPosition: TutorialArrowPosition.LEFT,
      offset: 12,
    },
  ],
  [TutorialProducts.MATH_TASK]: [
    {
      target: '.learning-path-card-tutorial-step-1',
      icon: 'hexagon',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.TOP,
      arrowPlacement: TutorialPlacement.BOTTOM,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 12,
    },
  ],
  [TutorialProducts.CURRICULUM_TUTORIAL_1]: [
    {
      target: '.curriculum-pop-up-tutorial-caps',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.BOTTOM,
      arrowPlacement: TutorialPlacement.TOP,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 20,
    },
    {
      target: '.curriculum-pop-up-tutorial-certificate',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.TOP,
      arrowPlacement: TutorialPlacement.BOTTOM,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 20,
    },
    {
      target: '.curriculum-pop-up-tutorial-mq-card',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.BOTTOM,
      arrowPlacement: TutorialPlacement.TOP,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 20,
    },
  ],
  [TutorialProducts.CURRICULUM_TUTORIAL_2]: [
    {
      target: '.curriculum-pop-up-tutorial-prerequisites',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.BOTTOM,
      arrowPlacement: TutorialPlacement.TOP,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 20,
    },
    {
      target: '.curriculum-pop-up-tutorial-caps',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.BOTTOM,
      arrowPlacement: TutorialPlacement.TOP,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 20,
    },
    {
      target: '.curriculum-pop-up-tutorial-certificate',
      icon: '',
      emoji: '',
      disableBeacon: true,
      placement: TutorialPlacement.TOP,
      arrowPlacement: TutorialPlacement.BOTTOM,
      arrowPosition: TutorialArrowPosition.CENTER,
      offset: 20,
    },
  ],
  [TutorialProducts.EMPTY]: [],
}
